document.addEventListener("alpine:init", () => {
    Alpine.data("apartment", ({ mewsCategoryId, date_in, date_out, price_id, num_people }) => ({
        mewsCategoryId: mewsCategoryId,
        dateIn: null,
        dateOut: null,
        numPeople: 2,
        prices: '',
        canBook: false,
        abortController: null,
        isLoading: false,
        selectedRate: null,
        error: null,
        fp: null,
        init() {
            const self = this;

            this.fp = flatpickr(".flatpickr", {
                mode: "range",
                dateFormat: "d-m-Y",
                minDate: "today",
                locale: flatpickr.l10ns[lang] || flatpickr.l10ns.default,
                onChange(selectedDates, dateStr, instance) {
                    if (selectedDates.length === 2) {
                        self.dateIn  = self.formatDateDefault(selectedDates[0]);
                        self.dateOut = self.formatDateDefault(selectedDates[1]);
                        self.checkReady();
                    }
                }
            });

            this.$watch('numPeople', () => {
                if (this.dateIn && this.dateOut) {
                    this.checkReady();
                }
            });

            if (date_in && date_out ) {

               this.dateIn = date_in;
               this.dateOut = date_out;
               this.fp.setDate([self.formatDateDMY(date_in), self.formatDateDMY(date_out)], false);
               this.checkReady();
            }
            if(num_people){
                this.numPeople = num_people;
                this.checkReady();
            }

            this.initMewsBookingEngine();

        },

        initMewsBookingEngine(){
            const self = this;
            Mews.Distributor(
                // Set Configuration ID of your booking engine.
                {
                    configurationIds: ['78dff102-9b8c-4ab0-89fe-b260011c968f'],
                },

                // Add callback which will enable Submit button and open the Booking Engine Widget upon button click.
                function (api) {
                    // Listen on submit and when user submits, open booking engine with given dates.
                    const listenOnSubmit = () => {
                        // Find the form in DOM and listen on submit.
                        const form = document.getElementById('mews-form');

                        form.addEventListener('submit', event => {
                            // Don't use the default submit button behavior. We want to handle it ourselves.
                            event.preventDefault();
                            // Get the dates from the date form.
                            const [startYears, startMonths, startDays] = self.dateIn.split('-');
                            const [endYears, endMonths, endDays] = self.dateOut.split('-');

                            const startDate = new Date(startYears, startMonths, startDays);
                            const endDate = new Date(endYears, endMonths, endDays);

                            api.setStartDate(startDate);
                            api.setEndDate(endDate);
                            api.setAdultCount(parseInt(self.numPeople));

                            switch (document.documentElement.lang) {
                                case 'en':
                                    lang = 'en-US';
                                    break;
                                default:
                                    lang = `${document.documentElement.lang}-${document.documentElement.lang.toUpperCase()}`;
                            }

                            api.setLanguageCode(lang);
                            api.showRates(self.mewsCategoryId);

                            api.open();
                        });
                    };

                    listenOnSubmit();

                    // Enable the submit button, because the Booking Engine Widget is ready to be used.
                    const enableSubmit = () => {
                        const submitButton = document.getElementById('dates-submit');
                        submitButton.value = 'Submit';
                        submitButton.disabled = false;
                    };
                    //enableSubmit();
                },
            );
        },

        async checkReady(instance = null) {
            if (!this.dateIn || !this.dateOut || !this.numPeople) {
                this.canBook = false;
                return;
            }
            this.canBook = true;
            this.prices = null;
            this.selectedRate = true;

        },
        formatDateDefault(dateObj) {
            const year  = dateObj.getFullYear();
            const month = String(dateObj.getMonth() ).padStart(2, '0'); // 01-12
            const day   = String(dateObj.getDate()).padStart(2, '0');      // 01-31
            return `${year}-${month}-${day}`;
        },

        formatDateDMY(value) {
            if (!value) return '';

            const d = value instanceof Date ? value : new Date(value);
            if (isNaN(d)) return '';

            const year  = d.getFullYear();
            const month = String(d.getMonth() + 1).padStart(2, '0');
            const day   = String(d.getDate()).padStart(2, '0');

            return `${day}-${month}-${year}`;
        },

        formatEUR(v) {
            const n = Number(v);
            if (!Number.isFinite(n)) return '';
            return new Intl.NumberFormat('es-ES', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(n);
        }

    }));
});